import { Pie } from '@ant-design/plots';

import DataLargeBlock from "../../containers/DataLargeBlock";

import styles from "./donat-chart.module.scss";

import config, {colors} from "./config";

const DonatChart = ({title, data, summary}) => {

    const donatConfig = {...config, data};

    const summaryElements = summary.map((value, index) => <div key={index} className={styles.summaryItem}><span style={{backgroundColor: colors[index]}} className={styles.summaryBadge}></span>{value}</div>)

    return (
        <DataLargeBlock>
            <div className={styles.heading}>
                <span className={styles.title}>{title}</span>
                {/*<div className={styles.periodBox}>Specific period</div>*/}
            </div>
            <Pie {...donatConfig} />
            {summary.length > 0 && <div className={styles.summaryBLock}>{summaryElements}</div>}
        </DataLargeBlock>
    )
};

export default DonatChart;

DonatChart.defaultProps = {
    data: [],
    summary: [],
}
